import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useMemo, useEffect } from "react";
export const ConfirmationPageContext = createContext(null);
export const ConfirmationPageProvider = ({ children, }) => {
    const [showConfirm, setShowConfirm] = useState(false);
    const [isFromContactForm, setIsFromContactForm] = useState(false);
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const view = urlParams.get("view");
        const checkViewInURL = () => {
            if (isFromContactForm) {
                setShowConfirm(view === "confirm");
            }
            else {
                cleanUrl();
                setShowConfirm(false);
            }
        };
        if (view === "confirm") {
            checkViewInURL();
        }
        window.addEventListener("popstate", checkViewInURL);
        return () => {
            window.removeEventListener("popstate", checkViewInURL);
        };
    }, [isFromContactForm]);
    const triggerConfirmView = () => {
        const url = new URL(window.location.href);
        url.searchParams.set("view", "confirm");
        setIsFromContactForm(true);
        window.history.replaceState({}, "", url.toString());
        setShowConfirm(true);
    };
    const cleanUrl = () => {
        const url = new URL(window.location.href);
        url.searchParams.delete("view");
        window.history.replaceState({}, "", url.toString());
    };
    const contextValue = useMemo(() => ({
        showConfirm,
        triggerConfirmView,
    }), [showConfirm]);
    return (_jsx(ConfirmationPageContext.Provider, { value: contextValue, children: children }));
};
